/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationTriggerRuleDto
 */
export interface IntegrationTriggerRuleDto {
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    instanceTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    mappingId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    ruleScope?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    subscriberUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    effectTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationTriggerRuleDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    entityType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationTriggerRuleDto
     */
    changeTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IntegrationTriggerRuleDto
     */
    watchFields?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationTriggerRuleDto
     */
    conditionRule?: { [key: string]: any; };
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof IntegrationTriggerRuleDto
     */
    actions?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof IntegrationTriggerRuleDto
     */
    actionPolicy?: string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationTriggerRuleDto
     */
    coalesceWindowMs?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationTriggerRuleDto
     */
    coalesceMaxEntities?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationTriggerRuleDto
     */
    maxTriggersPerMinute?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationTriggerRuleDto
     */
    allowSameInstanceLoop?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationTriggerRuleDto
     */
    suppressCrossVendorEcho?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IntegrationTriggerRuleDto
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationTriggerRuleDto
     */
    version?: number;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationTriggerRuleDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationTriggerRuleDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the IntegrationTriggerRuleDto interface.
 */
export function instanceOfIntegrationTriggerRuleDto(value: object): value is IntegrationTriggerRuleDto {
    return true;
}

export function IntegrationTriggerRuleDtoFromJSON(json: any): IntegrationTriggerRuleDto {
    return IntegrationTriggerRuleDtoFromJSONTyped(json, false);
}

export function IntegrationTriggerRuleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationTriggerRuleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'instanceTenantId': json['instanceTenantId'] == null ? undefined : json['instanceTenantId'],
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'mappingId': json['mappingId'] == null ? undefined : json['mappingId'],
        'ruleScope': json['ruleScope'] == null ? undefined : json['ruleScope'],
        'subscriberUserId': json['subscriberUserId'] == null ? undefined : json['subscriberUserId'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'changeTypes': json['changeTypes'] == null ? undefined : json['changeTypes'],
        'watchFields': json['watchFields'] == null ? undefined : json['watchFields'],
        'conditionRule': json['conditionRule'] == null ? undefined : json['conditionRule'],
        'actions': json['actions'] == null ? undefined : json['actions'],
        'actionPolicy': json['actionPolicy'] == null ? undefined : json['actionPolicy'],
        'coalesceWindowMs': json['coalesceWindowMs'] == null ? undefined : json['coalesceWindowMs'],
        'coalesceMaxEntities': json['coalesceMaxEntities'] == null ? undefined : json['coalesceMaxEntities'],
        'maxTriggersPerMinute': json['maxTriggersPerMinute'] == null ? undefined : json['maxTriggersPerMinute'],
        'allowSameInstanceLoop': json['allowSameInstanceLoop'] == null ? undefined : json['allowSameInstanceLoop'],
        'suppressCrossVendorEcho': json['suppressCrossVendorEcho'] == null ? undefined : json['suppressCrossVendorEcho'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'version': json['version'] == null ? undefined : json['version'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function IntegrationTriggerRuleDtoToJSON(json: any): IntegrationTriggerRuleDto {
    return IntegrationTriggerRuleDtoToJSONTyped(json, false);
}

export function IntegrationTriggerRuleDtoToJSONTyped(value?: IntegrationTriggerRuleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'instanceTenantId': value['instanceTenantId'],
        'instanceId': value['instanceId'],
        'mappingId': value['mappingId'],
        'ruleScope': value['ruleScope'],
        'subscriberUserId': value['subscriberUserId'],
        'effectTenantId': value['effectTenantId'],
        'name': value['name'],
        'enabled': value['enabled'],
        'entityType': value['entityType'],
        'changeTypes': value['changeTypes'],
        'watchFields': value['watchFields'],
        'conditionRule': value['conditionRule'],
        'actions': value['actions'],
        'actionPolicy': value['actionPolicy'],
        'coalesceWindowMs': value['coalesceWindowMs'],
        'coalesceMaxEntities': value['coalesceMaxEntities'],
        'maxTriggersPerMinute': value['maxTriggersPerMinute'],
        'allowSameInstanceLoop': value['allowSameInstanceLoop'],
        'suppressCrossVendorEcho': value['suppressCrossVendorEcho'],
        'priority': value['priority'],
        'version': value['version'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

